import useSWR from 'swr';
import {
    AutoCompleteKeyMap,
    AutoCompleteSingleItemEndpointMap
} from '../../components/GrispiInput/components/GrispiAutoCompleteInput';
import { GroupWithUsers, IForm, Organization, customSWRConfig, customSWRResponse } from '../../model/types';
import { endUserPublicFetcher, fetcherWithToken } from '../../utils/fetchers';
import { nonNullishValue } from '../../utils/helpers';
import useSWRCacheKeys, { usePublicApiSWRCacheKeys } from '../useSWRCacheKeys';

export default function useSingleAutocompleteItemById(
    autocompleteKey: AutoCompleteKeyMap,
    autoCompleteKeyId: number,
    isPublic: boolean = false,
    config: customSWRConfig = {}
): customSWRResponse<GroupWithUsers | Organization | IForm> {
    const keys = useSWRCacheKeys(
        +autoCompleteKeyId ? `${AutoCompleteSingleItemEndpointMap[autocompleteKey]}/${autoCompleteKeyId}` : null
    );
    const publicKeys = usePublicApiSWRCacheKeys(
        +autoCompleteKeyId ? `${AutoCompleteSingleItemEndpointMap[autocompleteKey]}/${autoCompleteKeyId}` : null
    );
    const isKeyExists = nonNullishValue(keys) || nonNullishValue(publicKeys);

    return useSWR<GroupWithUsers | Organization | IForm>(
        isKeyExists ? (isPublic ? publicKeys : keys) : null,
        isPublic ? endUserPublicFetcher : fetcherWithToken,
        { ...config }
    );
}
